import { render } from "./IncludedItemOriginalPackaging.vue?vue&type=template&id=4e7e9874"
import script from "./IncludedItemOriginalPackaging.vue?vue&type=script&lang=js"
export * from "./IncludedItemOriginalPackaging.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__